<template>
  <v-container id="bid-specification" fluid tag="section" class="main-container">
    <idc-component-bid-specification
      :settings="settings"
      :can-edit="canEdit"
      :can-read="canRead"
      :can-delete="canDelete"
      :can-clone="canClone"
      :can-submit-bid="canSubmitBid"
      :can-remove-comments="canRemoveComments"
      :url-paper-work="urlPaperWork"
      :url-equipment="urlEquipment"
    />
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'
  import Path from '@/utilities/bid/enums/Path'

  export default Vue.extend({
    name: 'DashboardBidSpecification',
    components: {
      IdcComponentBidSpecification: () => import('@/components/idc/bids/Specification'),
    },
    props: {
      canEdit: {
        type: Boolean,
        default: () => true,
      },
      canRead: {
        type: Boolean,
        default: () => true,
      },
      canDelete: {
        type: Boolean,
        default: () => true,
      },
      canClone: {
        type: Boolean,
        default: () => true,
      },
      canSubmitBid: {
        type: Boolean,
        default: () => true,
      },
      canRemoveComments: {
        type: Boolean,
        default: () => false,
      },
      urlPaperWork: {
        type: String,
        default: () => Path.SALES_BIDS_PAPERWORK,
      },
      urlEquipment: {
        type: String,
        default: () => Path.SALES_BIDS_EQUIPMENT,
      },
    },
    computed: {
      ...mapState('Settings', ['settings']),
    },
  })
</script>
